import styled from '@emotion/styled'
import { Box } from '@mui/material'

import { CUI_BANNER_TEXT, type EnvironmentMarking } from '@/utils/environmentMarking'

const HeaderWrapper = styled('header')`
  width: 100%;
`

interface HeaderProps {
  confidentiality?: 'company-confidential' | 'non-company-confidential'
  /**
   * Resolved environment marking. `gcc-cui` replaces the per-model
   * confidentiality banner with the always-on CUI banner; `commercial`
   * (and unset) keeps today's behavior.
   */
  environmentMarking?: EnvironmentMarking
}

export default function Header({ confidentiality, environmentMarking }: HeaderProps) {
  if (environmentMarking === 'gcc-cui') {
    return (
      <HeaderWrapper id="app__header">
        <Box
          id="app__header-banner"
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 700,
            fontSize: { xs: '13px', sm: '16px', md: '20px' },
            lineHeight: 1.35,
            px: 1,
            py: '2px',
            minHeight: '30px',
            background: t => t.palette.dataSecurity.cui.bg,
            color: t => t.palette.dataSecurity.cui.fg,
          }}
        >
          <span>{CUI_BANNER_TEXT}</span>
        </Box>
      </HeaderWrapper>
    )
  }

  return (
    <HeaderWrapper id="app__header">
      <Box
        id="app__header-banner"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textTransform: 'uppercase',
          fontWeight: 700,
          fontSize: '20px',
          transition: 'background 0.3s ease',
          background: t => {
            if (confidentiality === 'non-company-confidential') return t.palette.dataSecurity.nonCompanyConfidential.bg
            if (confidentiality === 'company-confidential') return t.palette.dataSecurity.companyConfidential.bg
            return 'transparent'
          },
          minHeight: '30px',
          overflow: 'hidden',
        }}
      >
        {confidentiality && (
          <span>
            UNCLASSIFIED // {confidentiality === 'non-company-confidential' && 'NON '}
            COMPANY CONFIDENTIAL
          </span>
        )}
      </Box>
    </HeaderWrapper>
  )
}
